import moment from "moment";
import React from "react";
import type { IGraveDetail } from "service/interface/grave";

interface Props {
  data: IGraveDetail;
}

export function DetailInfoTable({ data }: Props) {
  return (
    <div>
      <div className="mb-[24px] flex items-center justify-between">
        <p className="m-0 text-[24px] font-semibold leading-[30px] text-black">
          상세 정보
        </p>
      </div>
      <div className="w-full border-t-[2px] border-t-black p-0">
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            부비 주소
          </div>
          <div className="flex h-full w-[790px] items-center px-[12px] text-M3 text-gray-5">
            {data.address}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            부지 면적
          </div>
          <div className="flex h-full w-[790px] items-center px-[12px] text-M3 text-gray-5">
            {data.area}
          </div>
        </div>
        <div className="flex h-[58px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            이장/개장 필요
          </div>
          <div className="flex h-full w-[790px] items-center px-[12px] text-M3 text-gray-5">
            {data.isGraveMove ? "예" : "아니오"}
          </div>
        </div>
        <div className="flex h-[190px] w-full border-b-[1px] border-b-gray-1">
          <div className="flex h-full w-[148px] items-center justify-center bg-[#f4f4f4] text-M3 text-gray-4">
            기타
          </div>
          <div className="flex h-full w-[790px] items-center px-[12px] text-M3 text-gray-5">
            <textarea
              readOnly
              value={data.etc}
              className="m-0 h-[166px] w-full resize-none border-none p-0 focus:ring-white"
            />
          </div>
        </div>
      </div>
    </div>
  );
}
